import { useState } from "react";
import Input from "../ui/InputForm";
import Button from "../ui/Button";
import "./AuthForm.css";

function SignUpForm({ onSubmit }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Sign up</h2>

      <Input
        label="Naam"
        type="text"
        name="name"
        placeholder="Voornaam en achternaam"
        value={formData.name}
        onChange={handleChange}
        required
      />

      <Input
        label="Email"
        type="email"
        name="email"
        placeholder="Emailadres"
        value={formData.email}
        onChange={handleChange}
        required
      />

      <Input
        label="Password"
        type="password"
        name="password"
        placeholder="Kies wachtwoord"
        value={formData.password}
        onChange={handleChange}
        minLength={8}
        required
      />
      <small>Minimaal 8 karakters</small>

      <Button type="submit" variant="primary" fullWidth>
        Sign up
      </Button>
    </form>
  );
}

export default SignUpForm;